import moment from "moment";
import { BudgetPeriod } from "@/services/cloudchipr.api";

export const isBudgetUsedDataNoCollected = (
  used: number,
  startDate?: string,
  period?: BudgetPeriod,
) => {
  const isTodayOrYesterday =
    moment(startDate).isSame(moment(), "day") ||
    moment(startDate).isSame(moment().subtract(1, "day"), "day");

  return !!(startDate && isTodayOrYesterday && period === "daily" && !used);
};
